// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__wEUhU","head":"ProcedureTableInfo_head__3EFdi"};